module.exports = __webpack_public_path__ + "images/facebook@3x.png?14ff083d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook@3x.png
// module id = 623
// module chunks = 7